/**
 * Utility functions for communicating with the parent window
 */

// Send a message to the parent window
export function sendMessageToParent(message: any, targetOrigin = "*") {
  if (typeof window !== "undefined" && window.parent) {
    console.log(`Sending message to parent:`, message)
    window.parent.postMessage(message, targetOrigin)
  } else {
    console.warn("Cannot send message: window or parent not available")
  }
}

// Request a token from the parent window
export function requestTokenFromParent() {
  sendMessageToParent({ action: "REQUEST_TOKEN" })
}

// Request a new token due to authentication failure
export function requestTokenDueToAuthFailure(error?: string) {
  sendMessageToParent({
    action: "REQUEST_TOKEN",
    reason: "auth_failure",
    error: error,
  })
}

// Send navigation message to parent window
export function navigateInParent(route: string, options: { replaceUrl?: boolean; openInNewTab?: boolean; isInternalRoute?: boolean } = {}) {
  const { replaceUrl = false, openInNewTab = false, isInternalRoute = false } = options
  
  sendMessageToParent({
    action: "NAVIGATE",
    route: route,
    replaceUrl: replaceUrl,
    openInNewTab: openInNewTab,
    isInternalRoute: isInternalRoute,
  })
}

// Notify parent of internal route changes within this app
export function notifyParentOfRouteChange(path: string) {
  sendMessageToParent({
    action: "ROUTE_UPDATE",
    path: path,
  })
}

// Send title update to parent window
export function updateParentTitle(title: string) {
  sendMessageToParent({
    action: "UPDATE_TITLE",
    title: title,
  })
}

// Listen for messages from the parent window
export function listenToParentMessages(callback: (event: MessageEvent) => void) {
  if (typeof window !== "undefined") {
    window.addEventListener("message", callback)
    return () => window.removeEventListener("message", callback)
  }
  return () => {}
}

// Notify parent of dirty state changes
export function notifyParentOfDirtyState(isDirty: boolean) {
  sendMessageToParent({
    action: "SET_DIRTY_STATE",
    isDirty: isDirty,
  })
}

// Request navigation confirmation from parent
export function requestNavigationConfirmation() {
  sendMessageToParent({
    action: "REQUEST_NAVIGATION_CONFIRMATION",
  })
}